<template>
  <div id="">
      <v-app >
        <v-main>
          <UserNavbar/>
          <AuthenticationCallback/>
        </v-main>
      </v-app>
  </div>
</template>

<script>
import UserNavbar from '@/components/PublicNavbar'
import AuthenticationCallback from '../components/AuthenticationCallback'
export default {
  props: {
  },
  components: {
    UserNavbar,
    AuthenticationCallback
  }
}
</script>
